<template>
  <div class="underwater-bg" ref="container">
    <!-- Floating ducks as DOM elements -->
    <div class="fixed inset-0 z-0 pointer-events-none">
      <img src="/ducksImages/duckIcon.webp" class="floating-duck duck2 w-24 h-24 opacity-20" />
      <img src="/ducksImages/duckIcon.webp" class="floating-duck duck3 w-20 h-20 opacity-20" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const container = ref<HTMLDivElement | null>(null);
</script>

<style scoped>
.underwater-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  transform: translateZ(0);
  will-change: transform;
  background: linear-gradient(180deg,
    #87cefa 0%,
    #6ab7ff 20%,
    #3a7bd5 50%,
    #215fad 80%,
    #184890 100%
  );
  transition: background 0.5s ease;
}

/* dark mode support */
.underwater-bg:global(.dark-mode),
:root.dark .underwater-bg {
  background: linear-gradient(180deg,
    #1e3a5f 0%,
    #132f53 20%,
    #0b2447 50%,
    #081c3a 80%,
    #051630 100%
  );
}

/* Floating duck animations */
.floating-duck {
  position: absolute;
  animation: float 20s infinite linear;
}

.duck2 {
  left: 45%;
  animation-delay: -7s;
}

.duck3 {
  left: 75%;
  animation-delay: -14s;
}

@keyframes float {
  0% { transform: translateY(100vh) rotate(0deg); }
  100% { transform: translateY(-100px) rotate(360deg); }
}
</style>
